import { PaginatedResponse, PaginationType, SearchParams } from "helpers";
import { api } from "services";
import { imageToFormData, postImage } from "services/images";

import { pageToBody, resToPage } from "./transformations";
import { Page } from "./types";

export const getPages = async (
  pagination: PaginationType,
  search: SearchParams
): Promise<PaginatedResponse<Page>> => {
  const params = [
    `pageNumber=${pagination.currentPage}`,
    `pageSize=${pagination.pageSize}`,
    `sortBy=${search.sortBy}`,
    `desending=${search.descending}`,
    `search=${search.search}`,
  ];
  const url = `/pages?${params.join("&")}`;
  const resp = await api.get(url);
  return { data: resp.data.data.map(resToPage), meta: resp.data.meta };
};

export const getPage = async (id: number): Promise<Page> => {
  const resp = await api.get(`/pages/${id}`);
  return resToPage(resp.data);
};

export const putPage = async (data: Page): Promise<Page> => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = pageToBody(data);
  const resp = await api.put(`/pages/${data.id}`, body);
  return resToPage(resp.data);
};

export const postPage = async (data: Page) => {
  // Upload image
  if (data.image && data.image.buffer.byteLength) {
    const formData = imageToFormData(data.image);
    const newImage = await postImage(formData);
    data.image.id = newImage.id;
  }

  const body = pageToBody(data);
  const resp = await api.post(`/pages`, body);
  return resToPage(resp.data);
};

export const publishPage = async (id: number, published: boolean) => {
  const resp = await api.put(`pages/${id}/publish`, { published });
  return resToPage(resp.data);
};

export const deletePage = async (id: number): Promise<void> => {
  await api.delete(`/pages/${id}`);
};
